export default __webpack_public_path__ + "static/media/estrutura3.02993f1d.jpg";